module.exports = __webpack_public_path__ + "img/sa.01b40f1.svg";